'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSelectedRowKeys;

var _getFieldValue = require('../rows/getFieldValue');

var _getFieldValue2 = _interopRequireDefault(_getFieldValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getSelectedRowKeys(selectedRows, keyField) {
  return selectedRows.reduce(function (selectedRowsKeys, row) {
    var key = (0, _getFieldValue2["default"])(row, keyField);
    selectedRowsKeys[key] = true;
    return selectedRowsKeys;
  }, {});
}
/* eslint-disable no-param-reassign */